import { render, staticRenderFns } from "./NtrPrasymai.vue?vue&type=template&id=0cc90014&scoped=true&"
import script from "./NtrPrasymai.vue?vue&type=script&lang=js&"
export * from "./NtrPrasymai.vue?vue&type=script&lang=js&"
import style0 from "./NtrPrasymai.vue?vue&type=style&index=0&id=0cc90014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc90014",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
